export default function defineAvatarClip(svg: d3.Selection<'g'>, id: string, radius = 24): void {
  const defs = svg.append('svg:defs');

  defs.append('clipPath').attr('id', id).append('circle').attr('cx', 90).attr('cy', 40).attr('r', radius);
}
